/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainDriverCompanyTargetProgressStatus } from '../../entities/domain/DriverCompanyTargetProgressStatus'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainDriverCompanyTargetProgressStatusSchema = z.enum([
  'progress',
  'completed',
  'failed',
]) as unknown as ToZod<DomainDriverCompanyTargetProgressStatus>